import React, { useRef } from 'react';
import type { MasonryEngineNode } from '@leagueplatform/masonry-engine';
import { WidgetType } from '@leagueplatform/masonry-api';
import { LargeImageCard } from '#components/common/large-image-card/large-image-card.component.tsx';
import { ConditionalLinkCard } from '@leagueplatform/web-common-components';
import { LargeVisualCardContent } from './large-visual-card-content.component';
import type { LargeVisualCardContentProps } from './large-visual-card-content.component';
import { useGetTraitsForMedia } from '../../hooks/use-get-traits-for-media.hook';

export type LargeVisualCardWidgetProps = LargeVisualCardContentProps & {
  image: string;
  imageAltText?: string;
  isChildItem?: boolean;
};

export type LargeVisualCardWSNode = MasonryEngineNode<
  WidgetType.LARGE_VISUAL_CARD,
  LargeVisualCardWidgetProps
>;

export const LargeVisualCardWidget = ({
  image,
  imageAltText,
  isChildItem,
  linkUrl,
  traits,
  ...props
}: LargeVisualCardWidgetProps) => {
  const linkRefState = useRef<HTMLAnchorElement>(null);
  const traitItems = useGetTraitsForMedia(traits);
  const iconAlign = traitItems?.iconAlignment || 'right';

  return (
    <ConditionalLinkCard
      linkRef={linkRefState}
      hasLink={Boolean(linkUrl)}
      cardStyle={{ backgroundColor: 'surface.card.secondary' }}
    >
      <LargeImageCard
        image={image}
        imageAlign={iconAlign}
        imageAltText={imageAltText}
        isChildItem={isChildItem || traitItems?.isChildItem}
        imageLoading="lazy"
      >
        <LargeVisualCardContent
          linkUrl={linkUrl}
          linkRefState={linkRefState}
          traits={traits}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...props}
        />
      </LargeImageCard>
    </ConditionalLinkCard>
  );
};
